import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DashBoardActions } from "../../store/ducks/dashboard";
import Loading from "./Loading";
import { Conteiner } from "./styles";
import { ExecucaoProps } from "../../interfaces/execucao.interface";
import { Icon } from "../../styles/global";
import { P2Desk } from "../../styles/styles_text";
import VerifiedIcon from "../../assets/icons/verified_icon.svg";
import ArrowForward from "../../assets/icons/arrow_forward_ios.svg";
import ArrowForwardClosed from "../../assets/icons/arrow_forward_ios_closed.svg";
import AssimetriaIcon from "../../assets/icons/assimetria_icon.svg";
import DesequilibrioIcon from "../../assets/kinologyIcons/svg/desequilibrio_icon.svg";
import BlockedIcon from "../../assets/icons/blocked_icon.svg";
import EvolutionIcon from "../../assets/kinologyIcons/svg/evolution_icon.svg";
import CurvasIcon from "../../assets/kinologyIcons/svg/curvas.svg";
import { ReactComponent as HandFront } from "../../assets/kinologyIcons/svg/front_hand.svg";
import styled from "styled-components";
import { ReactComponent as PdfIcon } from "../../assets/kinologyIcons/svg/pdf.svg";
import PdfIconEmpty from "../../assets/kinologyIcons/svg/pdf-empty.svg";
import { RelatorioActions } from "../../store/ducks/relatorios";
import { AssimetriaPros } from "../../interfaces/assimetria.interface";
import {
	PacientesProps,
	UserProps,
} from "../../interfaces/pacientes.interface";
import * as Sentry from "@sentry/react";
import { AvaliationActions } from "../../store/ducks/avaliation";
import { TextsProps } from "../../database/txt.interface";
import { Colors } from "../../styles/colors";
import { AppActions } from "../../store/ducks/app";
import { TypesMenuInfoProps } from "../../utils/types";
import { ManageProtocolActions } from "../../store/ducks/manage_protocols";
import { getQuarter, sendErrorSentryOrLocalHost } from "../../utils/funcs";
import { apiFetch } from "../../services/httpClient";
import { PlanIds, useDataSubscription } from "../../hooks/useDataSubscription";
import WarningIcon from "../../assets/kinologyIcons/svg/warning.svg";
import ErrorIcon from "../../assets/kinologyIcons/svg/error.svg";
import {
	hasNoIncompleteAnamneses,
	hasQualityOfLifeHistory,
} from "./reportAvailability";

const typeOfJoint = [
	"QUADRIL",
	"JOELHO",
	"CERVICAL",
	"OMBRO",
	"COTOVELO",
	"PUNHO",
	"TORNOZELO",
];

interface HasReportProps {
	assimetry: boolean;
	forc_evolution: boolean;
	force_curves: boolean;
	muscle_balance: boolean;
	patient_evolution: boolean;
	prensao_palmar?: boolean;
	quality_life?: boolean;
	screening?: boolean;
}

const Relatorios: React.FC = () => {
	const dispatch = useDispatch();
	const current_language: TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);
	const execucoes_loading: boolean = useSelector(
		(state: any) => state.dashboard.execucoes_loading
	);
	const anamneses_loading: boolean = useSelector(
		(state: any) => state.dashboard.anamneses_loading
	);
	const assimetria_loading: boolean = useSelector(
		(state: any) => state.dashboard.assimetria_loading
	);

	const relatorio_anamneses = useSelector(
		(state: any) => state.anamnese.relatorio_anamnese
	);
	const execucoes: ExecucaoProps[] = useSelector(
		(state: any) => state.dashboard.execucoes
	);

	const historico_anamenses = useSelector(
		(state: any) => state.anamnese.historico_anamnese
	);

	const assimetrias: AssimetriaPros[] = useSelector(
		(state: any) => state.dashboard.assimetria
	);
	const dataReportPalmarGrip: any = useSelector(
		(state: any) => state.dashboard.palmar_gripe_data
	);

	const desequilibrios_object: any = useSelector(
		(state: any) => state.dashboard.desequilibrio
	);
	const user_logado: UserProps = useSelector((state: any) => state.auth.user);
	const language = useSelector((state: any) => state.configs.language);
	const paciente: PacientesProps = useSelector(
		(state: any) => state.app.is_open_paciente
	);
	const patient: PacientesProps = useSelector(
		(state: any) => state.app.is_open_paciente
	);
	const dataReport = useSelector(
		(state: any) => state.avaliation.data_report_EVA
	);
	const [loading, setLoading] = useState(false);

	const REPORT_WARNING_KEY = "@report_warning";

	const {
		currentPlan,
		registredUnifiedReport,
		selectedService,
		isPlanExpired,
	} = useDataSubscription("uni_complete_report");

	const isFreePlan = currentPlan?.name_indentification === PlanIds.FREE;

	const reportLimit = Number(selectedService?.value);
	const isLimitReached =
		selectedService?.value !== "unlimited" &&
		selectedService?.value !== undefined &&
		registredUnifiedReport >= reportLimit;

	const preLimitReportAlertUnderTwo =
		selectedService?.value !== "unlimited" &&
		selectedService?.value !== undefined &&
		registredUnifiedReport >= reportLimit - 2 &&
		registredUnifiedReport < reportLimit;

	const preLimitReportAlertUnderOne =
		selectedService?.value !== "unlimited" &&
		selectedService?.value !== undefined &&
		registredUnifiedReport >= reportLimit - 1 &&
		registredUnifiedReport < reportLimit;

	useEffect(() => {
		if (
			execucoes_loading ||
			anamneses_loading ||
			assimetria_loading ||
			!relatorio_anamneses
		) {
			setLoading(true);
		} else {
			setLoading(false);
		}
	}, [
		execucoes_loading,
		anamneses_loading,
		assimetria_loading,
		relatorio_anamneses,
	]);

	type EstadoPermitido =
		| "resultado_avaliacoes"
		| "escala_dor"
		| "qualidade_vida"
		| "anamnese"
		| "mapa_dor_eva"
		| "";
	const [resultado_selecionado, set_resultado_selecionado] =
		useState<EstadoPermitido>("");

	const showReportLimit =
		selectedService?.value !== "unlimited" &&
		selectedService?.value !== undefined &&
		Number(selectedService?.value) > 0;

	const [showWarningReport, setShowWarningReport] = useState(false);

	useEffect(() => {
		const now = new Date();
		const currentCycle = `${now.getFullYear()}-${now.getMonth() + 1}`;
		const dismissedCycle = localStorage.getItem(REPORT_WARNING_KEY);
		const shouldShow =
			preLimitReportAlertUnderTwo ||
			preLimitReportAlertUnderOne ||
			isLimitReached;

		setShowWarningReport(shouldShow && dismissedCycle !== currentCycle);
	}, [
		isLimitReached,
		preLimitReportAlertUnderOne,
		preLimitReportAlertUnderTwo,
	]);

	const closeWarning = (
		key: string,
		setState: React.Dispatch<React.SetStateAction<boolean>>
	) => {
		const now = new Date();
		const currentCycle = `${now.getFullYear()}-${now.getMonth() + 1}`;
		localStorage.setItem(key, currentCycle);
		setState(false);
	};

	function ChangeAreaResultado(area: EstadoPermitido) {
		if (execucoes.length > 0) {
			area === resultado_selecionado
				? set_resultado_selecionado("")
				: set_resultado_selecionado(area);
		}
	}

	function verifyQualityOfLife() {
		return hasQualityOfLifeHistory(historico_anamenses);
	}

	function verifyAnamneses() {
		return hasNoIncompleteAnamneses(historico_anamenses);
	}
	function verifyEva() {
		return (
			dataReport?.eva_corpo?.atual?.length > 0 ||
			(dataReport?.eva_corpo?.anterior?.length > 0 && true) ||
			false
		);
	}

	function verifyDesequilibrio() {
		let allowed = false;

		const desequilibrios_array: any =
			(!!desequilibrios_object && Object.values(desequilibrios_object)) || [];
		if (desequilibrios_array.length > 0 && !!verifyAssimetrys()) {
			typeOfJoint.map((item: any) => {
				desequilibrios_array.map((des: any) => {
					if (
						des.TITULO_TABELA[language?.toLowerCase()].toUpperCase() === item
					) {
						if (des?.REFERENCIAS?.length > 0) {
							des?.REFERENCIAS?.map((ref: any) => {
								if (ref?.EXECUCOES?.length > 0) allowed = true;
							});
						}
					}
				});
			});
		}
		return allowed;
	}

	function verifyAssimetrys() {
		let allowed = false;
		assimetrias.map((assi: any) => {
			if (assi.LISTAS?.INFERIOR_DORSAL.length) allowed = true;
			if (assi.LISTAS?.INFERIOR_FRONTAL.length) allowed = true;
			if (assi.LISTAS?.SUPERIOR_DORSAL.length) allowed = true;
			if (assi.LISTAS?.SUPERIOR_FRONTAL.length) allowed = true;
		});
		return allowed;
	}

	function verifyExecutions() {
		return execucoes.length > 0 ? true : false;
	}
	async function getReportEVA() {
		const data_request = {
			TOKEN: user_logado.token,
			txIdioma: language.toLowerCase(),
			ID_USUARIO: patient.ID_USUARIO,
		};
		try {
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(data_request),
			};

			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/relatorio_eva`,
				requestOptions
			);
			const response: any = await res.json();

			if (response?.pre_relatorio) {
				dispatch(AvaliationActions.set_data_report_EVA(response));
			}
		} catch (error) {
			sendErrorSentryOrLocalHost(error, {
				message: "Erro ao buscar pré relatório EVA - getReportEVA",
				tags: {
					endpoint: "/syncs/relatorio_eva",
					file: "src/pages/Relatorios/index.tsx",
				},
			});
		}
	}

	useEffect(() => {
		if (!execucoes_loading) getReportEVA();
	}, [execucoes_loading]);

	const currentQuarter = getQuarter("2025-09-05");

	return (
		<Conteiner>
			{loading ? (
				<P2Desk style={{ marginTop: "1rem" }}>Carregando...</P2Desk>
			) : (
				<>
					<div>
						{showWarningReport && showReportLimit && (
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									gap: "12px",
									color: Colors.neutral_grey_k_60,
									padding: "1rem",
									borderRadius: "10px",
									marginTop: "1rem",
									border: `1px solid ${
										preLimitReportAlertUnderOne
											? `${Colors.tertirary_red_2_dark}22`
											: `${Colors.tertiary_yellow_1_light}22`
									}`,
									backgroundColor: preLimitReportAlertUnderOne
										? `${Colors.tertirary_red_2_dark}22`
										: `${Colors.tertiary_yellow_1_light}22`,
								}}
							>
								<Icon
									src={preLimitReportAlertUnderOne ? ErrorIcon : WarningIcon}
									style={{
										width: 28,
										height: 28,
										flexShrink: 0,
									}}
								/>

								<p
									style={{
										margin: 0,
										flex: 1,
										lineHeight: "22px",
									}}
								>
									{preLimitReportAlertUnderOne
										? "Ao gerar o próximo, o "
										: "Você utilizou "}
									<strong>
										{preLimitReportAlertUnderOne
											? "acesso ao desktop será pausado até o próximo ciclo."
											: registredUnifiedReport +
											  " de " +
											  selectedService?.value +
											  " "}
										relatórios desse mês.{" "}
									</strong>
									{preLimitReportAlertUnderOne
										? "Você ainda poderá usar o app mobile."
										: "Ao atingir o limite, o acesso desktop será pausado até o próximo ciclo."}
									<br />
									<span
										onClick={() => {
											dispatch(
												AppActions.set_open_modal_upgrade_subscription(true)
											);
										}}
										style={{
											textDecoration: "underline",
											color: Colors.secondary_green_k_medium_1,
											fontWeight: 700,
											cursor: "pointer",
										}}
									>
										Conheça o Plano Premium →
									</span>
								</p>

								<button
									onClick={() =>
										closeWarning(REPORT_WARNING_KEY, setShowWarningReport)
									}
									style={{
										border: "none",
										background: "transparent",
										cursor: "pointer",
										fontSize: "22px",
										padding: 0,
										lineHeight: 1,
									}}
								>
									✕
								</button>
							</div>
						)}

						{(execucoes.length > 0 && (
							<AreaResultadosButton
								style={{ backgroundColor: "transparent" }}
								onClick={() => {
									dispatch(
										DashBoardActions.set_current_page("emissao_relatorios")
									);
								}}
							>
								<div style={{ display: "flex", alignItems: "center" }}>
									<PdfIcon
										style={
											{
												width: "1rem",
												height: "1rem",
												marginRight: "0.5rem",
												"--icon-color":
													preLimitReportAlertUnderOne ||
													preLimitReportAlertUnderTwo
														? Colors.tertiary_orange_1_dark
														: "#00A377",
											} as React.CSSProperties
										}
									/>

									<P2Desk
										style={{
											textDecorationLine: "underline",
											color:
												preLimitReportAlertUnderOne ||
												preLimitReportAlertUnderTwo
													? Colors.tertiary_orange_1_dark
													: "#00A377",
										}}
									>
										{current_language?.gerar_relatorio}
									</P2Desk>

									{(isFreePlan || isLimitReached || isPlanExpired) && (
										<P2Desk
											style={{
												textDecorationLine: "underline",
												color: "#00A377",
											}}
										>
											<span>&nbsp;</span>
											Free
										</P2Desk>
									)}

									{showReportLimit && !isPlanExpired && (
										<div
											style={{
												marginLeft: 6,
												paddingLeft: 8,
												paddingRight: 8,
												paddingTop: 2,
												paddingBottom: 2,
												borderWidth: 1,
												borderColor: Colors.neutral_grey_k_10,
												borderRadius: 14,
												backgroundColor: Colors.neutral_grey_k_10,
												alignSelf: "flex-start",
											}}
										>
											<P2Desk
												style={{
													fontWeight: "bold",
													color: preLimitReportAlertUnderTwo
														? Colors.tertiary_orange_1_dark
														: isLimitReached
														? Colors.neutral_grey_k_40
														: Colors.secondary_green_k_medium_1,
												}}
											>
												{registredUnifiedReport}
												<span style={{ fontSize: "0.75em" }}>
													/{selectedService?.value}
												</span>
											</P2Desk>
										</div>
									)}
								</div>
							</AreaResultadosButton>
						)) || (
							<AreaResultadosButton style={{ backgroundColor: "transparent" }}>
								<div style={{ display: "flex", alignItems: "center" }}>
									<Icon src={PdfIconEmpty} style={{ marginRight: "0.5rem" }} />
									<P2Desk
										style={{
											textDecorationLine: "underline",
											color: "#9497A4",
										}}
									>
										{current_language?.gerar_relatorio}
									</P2Desk>
								</div>
							</AreaResultadosButton>
						)}

						<AreaResultadosButton
							style={
								resultado_selecionado == "resultado_avaliacoes"
									? { backgroundColor: "#DEDFE3" }
									: { backgroundColor: "transparent" }
							}
							onClick={() => {
								verifyExecutions() &&
									ChangeAreaResultado("resultado_avaliacoes");
							}}
						>
							<div style={{ display: "flex", alignItems: "center" }}>
								<Icon
									src={verifyExecutions() ? VerifiedIcon : BlockedIcon}
									style={{ marginRight: "0.5rem" }}
								/>
								<P2Desk
									style={
										execucoes.length > 0
											? { color: "#000E4B" }
											: { color: "#ABADB7" }
									}
								>
									Resultado das avaliações
								</P2Desk>
							</div>
							<div style={{ display: "flex", alignItems: "center" }}>
								{!verifyExecutions() && (
									<P2Desk
										style={{
											marginRight: "1rem",
											textDecorationLine: "underline",
											cursor: "pointer",
										}}
										onClick={() =>
											dispatch(
												DashBoardActions.set_current_page(
													"protocols_in_patient"
												)
											)
										}
									>
										Avaliar
									</P2Desk>
								)}
								<Icon
									src={
										resultado_selecionado === "resultado_avaliacoes"
											? ArrowForward
											: ArrowForwardClosed
									}
								/>
							</div>
						</AreaResultadosButton>

						{resultado_selecionado == "resultado_avaliacoes" && (
							<>
								<AreaCadaResultado
									onClick={() => {
										verifyAssimetrys();
										dispatch(DashBoardActions.set_current_page("assimetria"));
										dispatch(
											DashBoardActions.set_request_verify_answer_nps(
												currentQuarter
											)
										);
									}}
								>
									<div style={{ display: "flex", alignItems: "center" }}>
										<Icon
											src={verifyAssimetrys() ? AssimetriaIcon : BlockedIcon}
											style={{ marginRight: "0.5rem" }}
										/>
										<P2Desk>Assimetria e indicativos de risco</P2Desk>
									</div>
									{(!verifyAssimetrys() && (
										<P2Desk
											style={{
												marginRight: "1rem",
												textDecorationLine: "underline",
												cursor: "pointer",
											}}
											onClick={() =>
												dispatch(
													DashBoardActions.set_current_page("assimetria")
												)
											}
										>
											Avaliar
										</P2Desk>
									)) || <Icon src={ArrowForward} />}
								</AreaCadaResultado>

								<AreaCadaResultado
									onClick={() => {
										verifyDesequilibrio();
										dispatch(
											DashBoardActions.set_current_page(
												"desequilibrio_muscular"
											)
										);
										dispatch(
											DashBoardActions.set_request_verify_answer_nps(
												currentQuarter
											)
										);
									}}
								>
									<div style={{ display: "flex", alignItems: "center" }}>
										<Icon
											src={
												verifyDesequilibrio() ? DesequilibrioIcon : BlockedIcon
											}
											style={{ marginRight: "0.5rem" }}
										/>
										<P2Desk>
											Desequilibrio muscular{" "}
											<P2Desk style={{ fontWeight: "bold" }}>(I/Q)</P2Desk>
										</P2Desk>
									</div>
									{(!verifyDesequilibrio() && (
										<P2Desk
											style={{
												marginRight: "1rem",
												textDecorationLine: "underline",
												cursor: "pointer",
											}}
											onClick={() =>
												dispatch(
													DashBoardActions.set_current_page("assimetria")
												)
											}
										>
											Avaliar
										</P2Desk>
									)) || <Icon src={ArrowForward} />}
								</AreaCadaResultado>

								<AreaCadaResultado
									onClick={() => {
										dispatch(
											DashBoardActions.set_current_page("relatorio_evolucao")
										);
										dispatch(
											DashBoardActions.set_request_verify_answer_nps(
												currentQuarter
											)
										);
									}}
								>
									<div style={{ display: "flex", alignItems: "center" }}>
										<Icon
											src={EvolutionIcon}
											style={{ marginRight: "0.5rem" }}
										/>
										<P2Desk>
											Histórico de força e valores de referência{" "}
											<P2Desk style={{ fontWeight: "bold" }}>(Evolução)</P2Desk>
										</P2Desk>
									</div>
									<Icon src={ArrowForward} />
								</AreaCadaResultado>

								<AreaCadaResultado
									onClick={() => {
										dispatch(
											DashBoardActions.set_current_page("relatorio_forca_tempo")
										);
										dispatch(
											DashBoardActions.set_request_verify_answer_nps(
												currentQuarter
											)
										);
									}}
								>
									<div style={{ display: "flex", alignItems: "center" }}>
										<Icon src={CurvasIcon} style={{ marginRight: "0.5rem" }} />
										<P2Desk>
											Dinâmica de força e desempenho muscular{" "}
											<P2Desk style={{ fontWeight: "bold" }}>
												(Força-Tempo)
											</P2Desk>
										</P2Desk>
									</div>
									<Icon src={ArrowForward} />
								</AreaCadaResultado>
								<AreaCadaResultado
									onClick={() => {
										dataReportPalmarGrip?.preensao_palmar?.indicativo_saude
											?.resultado
											? dispatch(
													DashBoardActions.set_current_page(
														"relatorio_preensao_palmar"
													)
											  )
											: [
													dispatch(
														AppActions.set_selected_options_page_patients(
															"avaliações"
														)
													),
													dispatch(
														DashBoardActions.set_select_info(
															TypesMenuInfoProps.BTN_MENU
														)
													),
													dispatch(
														ManageProtocolActions.set_button_goback(false)
													),
											  ];
										dispatch(
											DashBoardActions.set_request_verify_answer_nps(
												currentQuarter
											)
										);
									}}
								>
									<div style={{ display: "flex", alignItems: "center" }}>
										{dataReportPalmarGrip?.preensao_palmar?.indicativo_saude
											?.resultado ? (
											<HandFront
												color={Colors.secondary_green_k_main}
												style={{ marginRight: "0.5rem" }}
											/>
										) : (
											<Icon
												src={BlockedIcon}
												style={{ marginRight: "0.5rem" }}
											/>
										)}

										<P2Desk>Preensão Palmar</P2Desk>
									</div>
									{(!dataReportPalmarGrip?.preensao_palmar?.indicativo_saude
										?.resultado && (
										<P2Desk
											style={{
												marginRight: "1rem",
												textDecorationLine: "underline",
												cursor: "pointer",
											}}
											onClick={() => {
												dispatch(
													AppActions.set_selected_options_page_patients(
														"avaliações"
													)
												);
												dispatch(
													DashBoardActions.set_select_info(
														TypesMenuInfoProps.BTN_MENU
													)
												);
												dispatch(
													ManageProtocolActions.set_button_goback(false)
												);
											}}
										>
											Avaliar
										</P2Desk>
									)) || <Icon src={ArrowForward} />}
								</AreaCadaResultado>
							</>
						)}

						{/* Anamnese  */}

						<AreaResultadosButton
							style={
								resultado_selecionado == "anamnese"
									? { backgroundColor: "#DEDFE3" }
									: { backgroundColor: "transparent" }
							}
							onClick={() => {
								if (verifyAnamneses()) {
									ChangeAreaResultado("anamnese");
									dispatch(
										DashBoardActions.set_current_page("relatorio_anamnese")
									);
								}
								dispatch(
									DashBoardActions.set_request_verify_answer_nps(currentQuarter)
								);
							}}
						>
							<div style={{ display: "flex", alignItems: "center" }}>
								<Icon
									src={verifyAnamneses() ? VerifiedIcon : BlockedIcon}
									style={{ marginRight: "0.5rem" }}
								/>
								<P2Desk
									style={
										verifyAnamneses()
											? { color: "#000E4B" }
											: { color: "#ABADB7" }
									}
								>
									Anamnese
								</P2Desk>
							</div>
							<div style={{ display: "flex", alignItems: "center" }}>
								<Icon src={ArrowForwardClosed} />
							</div>
						</AreaResultadosButton>

						<AreaResultadosButton
							style={
								resultado_selecionado == "mapa_dor_eva"
									? { backgroundColor: "#DEDFE3" }
									: { backgroundColor: "transparent" }
							}
							onClick={() => {
								ChangeAreaResultado("mapa_dor_eva");
								dispatch(
									DashBoardActions.set_current_page("relatorio_pain_map")
								);
								dispatch(
									DashBoardActions.set_request_verify_answer_nps(currentQuarter)
								);
							}}
						>
							<div style={{ display: "flex", alignItems: "center" }}>
								<Icon
									src={verifyEva() ? VerifiedIcon : BlockedIcon}
									style={{ marginRight: "0.5rem" }}
								/>
								<P2Desk
									style={
										verifyEva() ? { color: "#000E4B" } : { color: "#ABADB7" }
									}
								>
									{current_language?.mapa_dor_indicativo_fibromialgia}
								</P2Desk>
							</div>
							<div style={{ display: "flex", alignItems: "center" }}>
								<Icon src={ArrowForwardClosed} />
							</div>
						</AreaResultadosButton>

						{/* Anamnese  */}

						<AreaResultadosButton
							style={
								resultado_selecionado == "qualidade_vida"
									? { backgroundColor: "#DEDFE3" }
									: { backgroundColor: "transparent" }
							}
							onClick={() => {
								if (verifyQualityOfLife()) {
									ChangeAreaResultado("qualidade_vida");
									dispatch(
										DashBoardActions.set_current_page(
											"relatorio_qualidade_vida"
										)
									);
								}
								dispatch(
									DashBoardActions.set_request_verify_answer_nps(currentQuarter)
								);
							}}
						>
							<div style={{ display: "flex", alignItems: "center" }}>
								<Icon
									src={verifyQualityOfLife() ? VerifiedIcon : BlockedIcon}
									style={{ marginRight: "0.5rem" }}
								/>
								<P2Desk
									style={
										verifyQualityOfLife()
											? { color: "#000E4B" }
											: { color: "#ABADB7" }
									}
								>
									Qualidade de vida
								</P2Desk>
							</div>
							<div style={{ display: "flex", alignItems: "center" }}>
								<Icon src={ArrowForwardClosed} />
							</div>
						</AreaResultadosButton>
					</div>
				</>
			)}
		</Conteiner>
	);
};

const AreaResultadosButton = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	cursor: pointer;
	background-color: #dedfe3;
	padding: 1rem;
	padding-top: 2rem;
	padding-bottom: 2rem;
	border-bottom: 1px solid var(--Neutras-Grey-K-10, #dedfe3);
`;

const AreaCadaResultado = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: 1rem;
	padding-left: 2rem;
	border-bottom: 1px solid var(--Neutras-Grey-K-10, #dedfe3);
`;

export default Relatorios;
